{
    "actions": {
        "page": {
            "multiple_block": {
                "title": "Blocage multiple",
                "select": "Blocage par sélection",
                "upload": "Blocage par fichier CSV"
            },
            "multiple_rewarehouse": "Restocker",
            "multiple_activation": "Activer"
        },
        "row": {
            "allow": "Autoriser",
            "block": "Blocage immédiat",
            "scheduled_block": "Blocage programmé",
            "temporarily_allow": "Temporairement autoriser",
            "rewarehouse": "Restockage",
            "refresh": "Rafraîchir le statut",
            "update_labels": "Modifier le terminal",
            "posTerminal_info_pos_status": "Info Statut TPE"
        }
    },
    "authorization_code": {
        "EMPTY": "Non renseigné",
        "02": "Contacter l'émetteur",
        "03": "Accepteur invalide",
        "04": "Conserver la carte",
        "05": "Ne pas honorer",
        "07": "Conserver la carte, conditions spéciales",
        "08": "Approuver après identification",
        "10": "Autorisation partielle",
        "12": "Transaction invalide",
        "13": "Montant invalide",
        "14": "Numéro de porteur invalide",
        "15": "Émetteur de carte inconnu",
        "17": "Annulation client",
        "19": "Répéter la transaction ultérieurement",
        "20": "Réponse erronnée (erreur dans le domaine serveur)",
        "21": "Transaction non exécutée",
        "24": "Mise à jour de fichier non supportée",
        "25": "Impossible de localiser l'enregistrement dans le fichier",
        "26": "Enregistrement dupliqué, ancien enregistrement remplacé",
        "27": "Erreur en \"edit\" sur le champ de mise à jour du fichier",
        "28": "Accès interdit au fichier",
        "29": "Mise à jour de fichier impossible",
        "30": "Erreur de format",
        "31": "Identifiant de l'organisme acquéreur inconnu",
        "32": "Transaction partiellement réalisée",
        "33": "Date de validité de la carte dépassée",
        "34": "Suspicion de fraude",
        "38": "Nombre d'essais code confidentiel dépassé",
        "41": "Carte perdue",
        "43": "Carte volée",
        "51": "Provision insuffisante ou crédit dépassé",
        "54": "Date de validité de la carte dépassée",
        "55": "Code confidentiel erroné",
        "56": "Carte absente du fichier",
        "57": "Transaction non permise à ce porteur",
        "58": "Transaction interdite au terminal",
        "59": "Suspicion de fraude",
        "60": "L'accepteur carte doit contacter l'acquéreur",
        "61": "Montant de retrait hors limite",
        "63": "Règles de sécurité non respectées",
        "68": "Réponse non parvenue ou reçue trop tard",
        "75": "Nombre d'essais code confidentiel dépassé",
        "76": "Porteur déjà en opposition, ancien enregistrement conservé",
        "90": "Arrêt momentané du système",
        "91": "Émetteur de cartes inaccessible",
        "94": "Demande dupliquée",
        "96": "Mauvais fonctionnement du système",
        "97": "Échéance de la temporisation de surveillance globale",
        "98": "Serveur indisponible, routage réseau demandé à nouveau",
        "99": "Incident domaine initiateur",
        "NR": "Pas de réponse reçue",
        "00": "Approuvée",
        "46": "Erreur métier spécifique",
        "62": "Carte à accès limité",
        "6P": "Échec de la vérification des données",
        "77": "Compte-cloturé",
        "78": "Carte bloquée, première transaction d'un nouveau titulaire de carte, et carte non correctement débloquée",
        "93": "La transaction ne peut être réalisée - Violation de la loi",
        "A0": "Repli en mode contact",
        "A1": "Soft decline",
        "A2": "PIN demandé en mode simple tap",
        "A3": "Nouveau tap avec authentification requise",
        "A4": "Mauvaise utilisation de l'exemple TRA",
        "R0": "Arrêt des ordres de paiement",
        "R1": "Révocation de tous les paiements électroniques récurrents pour la carte chez ce commerçant",
        "R3": "Révocation de tous les paiements récurrents pour la carte",
        "TNA": "Vide"
    },
    "authorization_code_result": {
        "AUTHORIZED": "Autorisé",
        "NOT_VERIFIED": "Validé",
        "REFUSED": "Refusé",
        "PENDING": "En attente",
        "EXPIRED": "Expiré",
        "CANCELLED": "Annulé"
    },
    "cb_logo": {
        "unknown_card": "Carte inconnue"
    },
    "entry_port": {
        "origin": "(Redirigé {{originEntryPort}})"
    },
    "filter": {
        "placeholder": {
            "provider_legal_name": "Filtrer par fournisseur direct",
            "serial_number": "Filtrer par # série",
            "manufacturer": "Filtrer par constructeur",
            "label": "Filtrer par libellé TPE",
            "custom_label": "Filtrer par libellé TPE 2",
            "event_logs": {
                "entry_port": "Filtrer par port",
                "x121_address": "Filtrer par centre X25",
                "application_id": "Filtrer par ITP",
                "acceptance_system_number": "Filtrer par rang",
                "bank_code": "Filtrer par code banque",
                "acceptance_agreement_number": "Filtrer par contrat",
                "company_registration_number": "Filtrer par SIRET"
            },
            "transactions": {
                "pan": "Filtrer par N° de carte",
                "contract": "Filtrer par contrat",
                "bank_code": "Filtrer par code banque",
                "rank": "Filtrer par rang",
                "authorization_number": "Filtrer par N° d'auto",
                "reconciliation_number": "Filtrer par N° de remise",
                "pos_remittance_number": "Filtrer par N° de fichier",
                "file_number": "Filtrer par N° de dossier",
                "legal_name": "Filtrer par nom commercial",
                "registration_number": "Filtrer par SIRET"
            }
        }
    },
    "keys": {
        "provider_legal_name": "Fournisseur direct",
        "serial_number": "# Série",
        "manufacturer": "Constr.",
        "label": "Libellé TPE",
        "custom_label": "Libellé TPE 2",
        "status": "Statut TPE",
        "rewarehouse_at": "En stock le",
        "network_interface_type": "Connexion",
        "last_gprs_call": "Dernière co. GPRS",
        "created_at": "Ajouté le",
        "updated_at": "Date de mise à jour",
        "last_connection_ip": "Dernière connexion IP",
        "blocked_at": "Bloqué le",
        "event_logs": {
            "network_information": {
                "entry_port": "Port"
            },
            "device_information": {
                "network_interface_type": "Type"
            },
            "destination_information": {
                "address": {
                    "x121_address": "Centre X25"
                }
            },
            "financial_information": {
                "operations": "Opérations",
                "acceptance_system_information": {
                    "application_id": "ITP",
                    "acceptance_system_number": "Rang",
                    "bank_code": "Code banque",
                    "acceptance_agreement_number": "Contrat",
                    "company_registration_number": "SIRET"
                }
            },
            "metrics_information": {
                "started_at": "Date d'appel"
            },
            "version_cb": "CB"
        },
        "sim": {
            "status": "Statut SIM",
            "activated_on": "Activé le",
            "offer": "Forfait"
        },
        "transactions": {
            "label": "Libellé TPE",
            "local_transaction_date_time": "Date",
            "pan": "N° de carte",
            "expiration_date": "Expir.",
            "amount": "Montant",
            "authorization_number": "N° d'auto",
            "authorization_code": "Code retour",
            "authorization_code_result": "Résultat",
            "type": "Type",
            "contract": "Contrat",
            "reconciliation_number": "N° de remise",
            "pos_remittance_number": "N° de fichier",
            "card_type": "Émetteur",
            "card_product": "Produit",
            "rank": "Rang",
            "bank_code": "Code banque",
            "legal_name": "Nom commercial",
            "registration_number": "SIRET",
            "file_number": "N° de dossier",
            "event_type": "Transactions"
        }
    },
    "modal": {
        "geolocation": {
            "title": "Géolocalisation des appels",
            "informations": "Informations données à titre indicatif",
            "error": {
                "api": "Une erreur est survenue lors de la géolocalisation du terminal",
                "map": "Carte indisponible"
            },
            "not_found": "Aucune information de géolocalisation disponible pour ce terminal",
            "not_found_ip": "Géolocalisation non disponible pour l'IP {{sourceAddressIp}}",
            "not_activated": {
                "title": "Géolocalisation des appels",
                "text": "Information non disponible"
            }
        },
        "unblacklist": {
            "title": "Autoriser le terminal",
            "text": "Voulez-vous autoriser ce terminal ?",
            "success": "Le terminal a été autorisé avec succès",
            "error": "Une erreur est survenue lors de l'autorisation du terminal",
            "no_connection_points": "Impossible d'autoriser le terminal : aucun point de connexion rattaché au terminal"
        },
        "blacklist": {
            "title": "Bloquer le terminal",
            "text": "Voulez-vous bloquer ce terminal ?",
            "success": "Le terminal a été bloqué avec succès",
            "error": "Une erreur est survenue lors du blocage du terminal",
            "no_connection_points": "Impossible de bloquer le terminal : aucun point de connexion rattaché au terminal",
            "scheduled": {
                "text": "Blocage programmé du terminal",
                "summary": "Le terminal sera bloqué le {{date}} à {{time}}",
                "success": "Le terminal est maintenant programmé pour être bloqué le {{date}} à {{time}}",
                "error": "Une erreur est survenue, le blocage n'a pas pu être programmé."
            }
        },
        "allow_temporarily": {
            "title": "Autoriser temporairement le terminal",
            "text": "Le terminal sera autorisé pendant 24h, voulez-vous continuer ?",
            "success": "Le terminal a été autorisé avec succès",
            "error": "Une erreur est survenue lors de l'autorisation du terminal",
            "no_connection_points": "Impossible d'autoriser temporairement le terminal : aucun point de connexion rattaché au terminal"
        },
        "rewarehouse": {
            "title": "Confirmation de remise en stock",
            "success": "Le terminal a été remis en stock avec succès",
            "error": "Une erreur est survenue lors de la remise en stock du terminal",
            "text_1": "Le terminal va être remis en stock, il ne sera plus lié au marchand actuel.",
            "text_2": "Il sera automatiquement affecté à un nouveau marchand lors de la prochaine télécollecte, autorisation ou lors du prochain téléparamétrage et apparaîtra de nouveau dans la liste des abonnements.",
            "text_3": "Souhaitez-vous continuer ?"
        },
        "update_labels": {
            "title": "Modifier les libellés du terminal",
            "label": "Libellé TPE",
            "custom_label": "Libellé TPE 2",
            "placeholder": "Maximum de 100 caractères",
            "success": "Les libellés du terminal ont été modifiés avec succès",
            "error": "Une erreur est survenue lors de la modification des libellés du terminal"
        },
        "info_status": {
            "title": "Statut du terminal",
            "serial_number": "# Série",
            "manufacturer": "Constructeur",
            "portal": "Statut TPE sur le portail (BdD)",
            "gateway": "Statut TPE sur la passerelle (Redis)",
            "key_list_redis": "Liste des clés Redis récupérées",
            "fetching_time": "Temps de récupération du statut Redis",
            "connexion_point": "Point d'accès",
            "value": "Valeur",
            "status": "Statut",
            "till": "jusqu'au"
        },
        "multiple_activation": {
            "title": "Activation multiple TPE",
            "success": "L'activation multiple a été réalisée avec succès !",
            "error": "Nous avons rencontré une erreur lors de l'activation multiple. Merci de réessayer.",
            "steps": {
                "select_pos_terminals": "Étape {{step}} sur {{maxStep}}: Sélectionnez les terminaux",
                "select_plan": "Étape {{step}} sur {{maxStep}}: Sélectionnez une offre",
                "confirmation": "Étape {{step}} sur {{maxStep}}: Confirmation"
            },
            "confirmation": {
                "text": "Vous avez sélectionné {{number}} TPE pour l'activation multiple",
                "question": "Souhaitez-vous continuer ?"
            }
        },
        "multiple_blocking": {
            "title": "Blocage multiple TPE",
            "success": "Le blocage multiple a été réalisé avec succès !",
            "error": "Nous avons rencontré une erreur lors du blocage multiple. Merci de réessayer.",
            "error_with_list1": "Le blocage multiple a été effectué partiellement à cause de la présence d'erreurs dans la liste.",
            "error_with_list2": "Vous trouverez ci-dessous la liste des numéros des TPE qui n'ont pas été bloqués :",
            "by_selection": {
                "steps": {
                    "select_subscription": "Étape {{step}} sur {{maxStep}}: Sélectionnez les terminaux (50 TPE maximum)",
                    "select_blocking_mode": "Étape {{step}} sur {{maxStep}}: Sélectionnez le type du blocage multiple",
                    "confirmation": "Étape {{step}} sur {{maxStep}}: Confirmation"
                },
                "confirmation": {
                    "text_1": "Vous avez sélectionné {{number}} TPE pour le blocage multiple",
                    "text_2": "Le blocage multiple prendra effet le {{date}} à {{time}}.",
                    "question": "Souhaitez-vous continuer ?"
                }
            }
        },
        "multiple_blocking_import": {
            "explanations": {
                "header": "Vous pouvez bloquer des terminaux par fichier CSV. Le fichier à importer doit contenir les 6 colonnes suivantes :",
                "organization": "Organisation : nom de l'organisation qui possède les terminaux à bloquer",
                "serial_number": "Série : numéro de série des terminaux à bloquer. Il peut comporter une ou plusieurs valeurs séparées par des virgules (exemple \"CT0881958, CT1234565, TH04072458\")",
                "direct_profider": "Fournisseur direct : nom du fournisseur direct du terminal",
                "constructor": "Constructeur : nom du constructeur du terminal",
                "label": "Libellé TPE ou code client : libellé du terminal ou le code client pour mieux identifier l'organisation",
                "siret": "Siret : numéro siret de l'organisation",
                "multiple_terminals": "Il est possible d'ajouter plusieurs terminaux pour une même organisation, pour cela le champ \"série\" doit être renseigné pour chacun des terminaux pour l'organisation en question. Un modèle avec des exemples est téléchargeable afin de vous aider à préparer votre fichier CSV.",
                "warning": "Attention : seuls les terminaux avec un statut d'abonnement activé et en attente, avec un statut TPE autorisé et temporaire sont blocables."
            },
            "confirmation": "Cette opération va bloquer {{numberOfTerminals}} terminaux. Souhaitez-vous continuer ?",
            "success": "Les terminaux ont été bloqués avec succès !",
            "error": {
                "invalid_file": "Ce fichier n'est pas compatible (.csv uniquement)",
                "header": "Le blocage multiple des terminaux a été effectué partiellement à cause de la présence d'erreurs dans le CSV. Vous trouverez ci-dessous la liste des terminaux qui n'ont pas été bloqués et leurs erreurs :",
                "footer": "Vous pouvez corriger ces erreurs et retenter l'opération de blocage des terminaux ensuite.",
                "BAD_FORMAT": "Erreur de format dans le fichier",
                "INTERNAL_SERVER_ERROR": "Une erreur inconnue est survenue",
                "MORE_THAN_ORGANIZATION_FOR_SINGLE_LINE": "Plus d'une organisation est fournie pour ce terminal",
                "MISSING_OR_EMPTY_VALUES": "Ce terminal a des valeurs manquantes ou vides",
                "POS_TERMINAL_NOT_FOUND": "Ce terminal n'est pas trouvé",
                "DUPLICATE_TERMINALS": "Ce terminal est dupliqué dans le fichier",
                "ORGANIZATION_NOT_FOUND": "L'organisation pour ce terminal n'est pas trouvée",
                "DIRECT_PROVIDER_NOT_FOUND": "Le fournisseur direct pour ce terminal n'est pas trouvé",
                "MULTIPLE_DIRECT_PROVIDERS_FOUND_FROM_LEGAL_NAME": "Plusieurs fournisseurs directs sont trouvés pour le nom du fournisseur direct fourni pour ce terminal",
                "MULTIPLE_ORGANIZATIONS_FOUND_FROM_LEGAL_NAME": "Plusieurs organisations sont trouvées pour le nom d'organisation fourni pour ce terminal",
                "POS_TERMINAL_SUBSCRIPTION_NOT_FOUND": "L'abonnement pour ce terminal n'est pas trouvé",
                "INCONSISTENT_VALUES": "Les valeurs relatives à ce terminal ne sont pas cohérentes",
                "EXCEEDING_POS_TERMINAL_MAXIMUM_COUNT": "Le nombre des terminaux à bloquer est dépassé",
                "POS_TERMINAL_ALREADY_BLOCKED": "Ce terminal est déjà bloqué",
                "POS_TERMINAL_SUBSCRIPTION_IN_STOCK": "L'abonnement associé à ce terminal est en stock, donc il n'est pas blocable ",
                "POS_TERMINAL_SUBSCRIPTION_TERMINATED": "L'abonnement associé à ce terminal est résilié, donc il n'est pas blocable",
                "POS_TERMINAL_SUBSCRIPTION_TERMINATION_IN_PROGRESS": "L'abonnement associé à ce terminal est en cours de résiliation, donc il n'est pas blocable",
                "BLACKLIST_ERROR": "Une erreur est survenue lors du blocage de ce terminal",
                "UNKNOWN_ERROR": "Une erreur inconnue est survenue lors du blocage de ce terminal",
                "UNEXPECTED_ERROR": "Une erreur inconnue est survenue",
                "BAD_FILE_FORMAT": "Le format du fichier est invalide."
            },
            "message": "Veuillez télécharger le fichier exemple."
        },
        "multiple_rewarehouse": {
            "title": "Remise en stock multiple",
            "success": "Remise en stock multiple réalisée avec succès !",
            "error_pos_terminal": "Une erreur est survenue pour le terminal suivant :",
            "error_pos_terminals": "Une erreur est survenue pour les terminaux suivants :",
            "steps": {
                "select_terminals": "Étape {{step}} sur {{maxStep}}: Sélectionnez les terminaux",
                "confirmation": "Étape {{step}} sur {{maxStep}}: Confirmation"
            },
            "confirmation": {
                "text_1": "Le terminal va être remis en stock, il ne sera plus lié au marchand actuel.",
                "text_2": "Il sera automatiquement affecté à un nouveau marchand lors de la prochaine télécollecte, autorisation ou lors du prochain téléparamètrage et apparaîtra de nouveau dans la liste des abonnements.",
                "question": "Souhaitez-vous continuer ?"
            }
        }
    },
    "network_interface_type": {
        "ETHERNET": "IP/Ethernet",
        "GPRS": "GPRS/3G",
        "WIFI": "Wifi",
        "PPP": "PPP",
        "PAYLUDD": "Appel app",
        "OTHER": "Inconnu",
        "NOT_SPECIFIED": "Pas spécifié"
    },
    "operation_type": {
        "authorization": "Autorisation",
        "remote_collection": "Télécollecte",
        "remote_configuration": "Téléparamétrage",
        "blacklisted_pos_terminal": "Bloqué",
        "pending_payment": "Notif. de paiement",
        "get_package": "Demande d'init.",
        "initialization_notification": "Notification d'init.",
        "terminal_state": "État du terminal"
    },
    "event_type": {
        "AUTHORIZATION": "Autorisation",
        "REMOTE_COLLECTION": "Remis",
        "NOT_COMPLETED": "Non aboutie",
        "INTERRUPTED": "Interrompue",
        "IN_PROGRESS": "En cours"
    },
    "sim": {
        "operator": "Un des opérateurs suivant:"
    },
    "status": {
        "TEMPORARILY_ALLOWED": "Temporaire",
        "ALLOWED": "Autorisé",
        "BLOCKED": "Bloqué"
    },
    "toast": {
        "refresh": {
            "loading": "Rafraîchissement en cours...",
            "success": "Rafraîchissement effectué avec succès",
            "error": "Une erreur est survenue lors du rafraîchissement"
        }
    },
    "tooltip": {
        "subscriptions": {
            "last_connection_type": "Type de la dernière connexion du terminal"
        },
        "transactions": {
            "file_number": "Référence d'archivage"
        }
    },
    "transaction_type": {
        "DEBIT": "Débit",
        "DEBIT_REVERSAL": "Annulation",
        "CREDIT": "Remboursement",
        "TNA": "En échec"
    },
    "card_product": {
        "1C": "Carte 1ère génération (4C)",
        "3C": "Carte 2ème génération (3C)",
        "3C4C": "Carte hybride (3C / 4C)"
    },
    "payludd": {
        "terminal_state": {
            "refresh": "Actualiser"
        },
        "state": {
            "application_version": "Application de paiement",
            "payludd_version": "Payludd",
            "android_version": "Android",
            "firmware": "Firmware",
            "initialization_status": "Statut d'initialisation",
            "package_code": "Code personnalisation",
            "package_label": "Nom personnalisation",
            "initialization_date": "Date d'initialisation",
            "last_update": "Dernière MAJ",
            "mode": "Mode",
            "payment_tickets": "Tickets de paiement",
            "additional_services": "Service additionnel",
            "burger_menu_lock": "Verrouillage menu",
            "logo": "Logo",
            "color": "Couleur"
        },
        "mpf": {
            "mode": {
                "CAISSE": "Caisse",
                "MANUEL": "Manuel",
                "DONS": "Dons",
                "AUTOMATE": "Automate",
                "EXTERNE_APP_TO_APP": "Externe (App to App)",
                "EXTERNE_CONCERT_V3": "Externe (Concert V3)",
                "EXTERNE_CONCERT_V2": "Externe (Concert V2)",
                "EXTERNE_CONCERT_V2_USB": "Externe (Concert V2 USB)"
            },
            "receipt": {
                "nativeMerchantReceipt": "Impression ticket commerçant",
                "nativeCustomerReceipt": "Impression ticket client",
                "dematerializedReceiptQrCode": "QR code ticket client"
            },
            "service": {
                "tip": "Pourboire",
                "enabled": "Pourboire activé sur le terminal",
                "disabled": "Pourboire désactivé sur le terminal",
                "waiterNumber": "Code employé",
                "tableNumber": "Référence commande"
            }
        },
        "initialization_status": {
            "INIT_OK": "Init OK",
            "INIT_KO": "Init KO",
            "NOT_INITIALIZED": "Non initialisé",
            "UNKNOWN": "—"
        },
        "monetic_contract": {
            "uncaptured_transactions": "Transaction(s) non télécollectée",
            "tlp_ready": "Prêt (TLP OK)",
            "yes": "Oui",
            "no": "Non"
        }
    },
    "event_logs": {
        "financial_information": {
            "acceptance_system_information": {
                "test_contract": "Contrat de test"
            }
        }
    }
}